module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-embed": "static-1.23798",
      "conversations-internal-schema": "static-1.11637",
      "head-dlb": "static-1.4130",
      "hs-test-utils": "static-1.6999",
      "hubspot-url-utils": "static-1.3313",
      "HubStyleTokens": "static-2.10522",
      "I18n": "static-7.1399",
      "jasmine-runner": "static-1.5426",
      "quartz": "static-1.5758",
      "react": "static-7.151",
      "sinon": "static-1.9",
      "webpack-env": "static-1.54",
      "isMobile": "static-1.7",
      "StyleGuideUI": "static-3.466",
      "visitor-ui-component-library": "static-1.5193",
      "enviro": "static-4.310",
      "hs-promise-rejection-tracking": "static-1.4492",
      "PortalIdParser": "static-2.288",
      "raven": "static-3.4958",
      "raven-hubspot": "static-1.5265",
      "bend-plugin-trellis-migration": "static-1.2623",
      "moment": "static-3.26",
      "cv-backend-services": "static-1.1243",
      "hub-http": "static-1.4807",
      "immutable": "static-2.19",
      "immutable-less": "static-1.3566",
      "quartz-core": "static-1.4977",
      "transmute": "static-2.29",
      "HeadJS": "static-2.584",
      "react-dom": "static-7.85",
      "foundations-components": "static-1.6251",
      "framer-motion": "static-1.42",
      "hs-test-utils-bend-plugin": "static-1.2110",
      "msw": "static-1.39",
      "react-redux": "static-7.16",
      "redux": "static-4.16",
      "testing-library": "static-1.123",
      "foundations-theming": "static-1.3312",
      "i18n-data": "static-1.199",
      "metrics-js": "static-1.8766",
      "moment-timezone": "static-5.51",
      "react-utils": "static-2.4488",
      "jasmine": "static-4.3355",
      "quartz-core-utils": "static-1.2625",
      "csstype": "static-1.38",
      "hoist-non-react-statics": "static-3.9",
      "PatternValidationJS": "static-1.437",
      "react-aria": "static-1.40",
      "styled-components": "static-2.64",
      "UIComponents": "static-3.7469",
      "visitor-ui-component-library-icons": "static-1.5004",
      "rpc-client-utils": "static-1.3741",
      "ts-schema": "static-1.3279",
      "hs-lodash": "static-4.45",
      "immer": "static-1.33",
      "copilot-toolkit": "static-1.7426",
      "dispatcher": "static-1.114",
      "general-store": "static-6.20",
      "history": "static-4.47",
      "hub-http-janus": "static-1.657",
      "hub-http-shared-msw-handlers": "static-1.7317",
      "hubspotter-http": "static-1.3750",
      "hubspotter-http-shared-msw-handlers": "static-1.7315",
      "icons": "static-2.592",
      "mobile-manifest-mixins": "static-1.355",
      "platform-navigation-bootstrap": "static-1.11430",
      "quick-fetch": "static-1.2772",
      "react-rhumb": "static-1.15568",
      "react-router-dom": "static-5.26",
      "ui-fonts": "static-1.332",
      "bend-plugin-foundations-components": "static-1.2520",
      "floating-ui": "static-1.30",
      "foundations-assets": "static-1.3906",
      "foundations-theming-specialty": "static-1.1029",
      "hs-story-utils": "static-1.8371",
      "react-select-plus": "static-1.65",
      "react-virtualized": "static-2.75",
      "tanstack-table": "static-1.23",
      "ui-images": "static-2.889",
      "bend-plugin-foundations-theming": "static-1.1795",
      "foundations-theming-base": "static-1.2297",
      "classnames": "static-2.10",
      "cssUtils": "static-1.532",
      "HubStyle": "static-2.10830",
      "chatspot-client-types": "static-1.9013",
      "chatspot-core": "static-1.16799",
      "sassPrefix": "static-1.133",
      "platform-infra-nav-components": "static-1.6863",
      "react-input-autosize": "static-2.17"
    },
    "depPathPrefixes": {
      "conversations-embed": "/conversations-embed/static-1.23798",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.11637",
      "head-dlb": "/head-dlb/static-1.4130",
      "hs-test-utils": "/hs-test-utils/static-1.6999",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3313",
      "HubStyleTokens": "/HubStyleTokens/static-2.10522",
      "I18n": "/I18n/static-7.1399",
      "jasmine-runner": "/jasmine-runner/static-1.5426",
      "quartz": "/quartz/static-1.5758",
      "react": "/react/static-7.151",
      "sinon": "/sinon/static-1.9",
      "webpack-env": "/webpack-env/static-1.54",
      "isMobile": "/isMobile/static-1.7",
      "StyleGuideUI": "/StyleGuideUI/static-3.466",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.5193",
      "enviro": "/enviro/static-4.310",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4492",
      "PortalIdParser": "/PortalIdParser/static-2.288",
      "raven": "/raven/static-3.4958",
      "raven-hubspot": "/raven-hubspot/static-1.5265",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.2623",
      "moment": "/moment/static-3.26",
      "cv-backend-services": "/cv-backend-services/static-1.1243",
      "hub-http": "/hub-http/static-1.4807",
      "immutable": "/immutable/static-2.19",
      "immutable-less": "/immutable-less/static-1.3566",
      "quartz-core": "/quartz-core/static-1.4977",
      "transmute": "/transmute/static-2.29",
      "HeadJS": "/HeadJS/static-2.584",
      "react-dom": "/react-dom/static-7.85",
      "foundations-components": "/foundations-components/static-1.6251",
      "framer-motion": "/framer-motion/static-1.42",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2110",
      "msw": "/msw/static-1.39",
      "react-redux": "/react-redux/static-7.16",
      "redux": "/redux/static-4.16",
      "testing-library": "/testing-library/static-1.123",
      "foundations-theming": "/foundations-theming/static-1.3312",
      "i18n-data": "/i18n-data/static-1.199",
      "metrics-js": "/metrics-js/static-1.8766",
      "moment-timezone": "/moment-timezone/static-5.51",
      "react-utils": "/react-utils/static-2.4488",
      "jasmine": "/jasmine/static-4.3355",
      "quartz-core-utils": "/quartz-core-utils/static-1.2625",
      "csstype": "/csstype/static-1.38",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "react-aria": "/react-aria/static-1.40",
      "styled-components": "/styled-components/static-2.64",
      "UIComponents": "/UIComponents/static-3.7469",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.5004",
      "rpc-client-utils": "/rpc-client-utils/static-1.3741",
      "ts-schema": "/ts-schema/static-1.3279",
      "hs-lodash": "/hs-lodash/static-4.45",
      "immer": "/immer/static-1.33",
      "copilot-toolkit": "/copilot-toolkit/static-1.7426",
      "dispatcher": "/dispatcher/static-1.114",
      "general-store": "/general-store/static-6.20",
      "history": "/history/static-4.47",
      "hub-http-janus": "/hub-http-janus/static-1.657",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.7317",
      "hubspotter-http": "/hubspotter-http/static-1.3750",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.7315",
      "icons": "/icons/static-2.592",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.355",
      "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.11430",
      "quick-fetch": "/quick-fetch/static-1.2772",
      "react-rhumb": "/react-rhumb/static-1.15568",
      "react-router-dom": "/react-router-dom/static-5.26",
      "ui-fonts": "/ui-fonts/static-1.332",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.2520",
      "floating-ui": "/floating-ui/static-1.30",
      "foundations-assets": "/foundations-assets/static-1.3906",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1029",
      "hs-story-utils": "/hs-story-utils/static-1.8371",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-virtualized": "/react-virtualized/static-2.75",
      "tanstack-table": "/tanstack-table/static-1.23",
      "ui-images": "/ui-images/static-2.889",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.1795",
      "foundations-theming-base": "/foundations-theming-base/static-1.2297",
      "classnames": "/classnames/static-2.10",
      "cssUtils": "/cssUtils/static-1.532",
      "HubStyle": "/HubStyle/static-2.10830",
      "chatspot-client-types": "/chatspot-client-types/static-1.9013",
      "chatspot-core": "/chatspot-core/static-1.16799",
      "sassPrefix": "/sassPrefix/static-1.133",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.6863",
      "react-input-autosize": "/react-input-autosize/static-2.17"
    },
    "project": "conversations-embed",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};